<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="serviceobjecttype_keyno" [ttModel]="edit.serviceobjecttype_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="serviceobjecttype_name" [(ttModel)]="edit.serviceobjecttype_name" ttRequired></tt-input>
        <tt-button-save ttText="serviceobjecttype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="serviceobjecttype_keyno" tt-model="vm.model.edit.serviceobjecttype_keyno" tt-change="vm.model.edit.serviceobjecttype_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="serviceobjecttype_name" tt-model="vm.model.edit.serviceobjecttype_name" tt-change="vm.model.edit.serviceobjecttype_name = $value" tt-placeholder=""></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="serviceobjecttype_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
